import { createElementVNode as _createElementVNode, mergeProps as _mergeProps, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["checked", "disabled"]
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", { class: "switch__slider" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("span", _mergeProps({ class: "switch" }, _ctx.$attrs), [
    _createElementVNode("input", {
      class: "switch__input",
      tabindex: "-1",
      type: "checkbox",
      checked: _ctx.modelValue,
      disabled: _ctx.disabled,
      onChange: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update:modelValue', $event.target.checked)))
    }, null, 40, _hoisted_1),
    _hoisted_2
  ], 16))
}